// firebase config
export const firebaseConfig = {
    apiKey: "AIzaSyDoauoLAUeFgeeXLcRmWtH_wJJsIAbj_dM",
    authDomain: "second-hand-11.firebaseapp.com",
    databaseURL: "https://second-hand-11-default-rtdb.firebaseio.com",
    projectId: "second-hand-11",
    storageBucket: "second-hand-11.appspot.com",
    messagingSenderId: "17135496441",
    appId: "1:17135496441:web:9494eafd27c6547d4cc628"
};